import React, { memo } from 'react'
import { areEqualProps } from '@dt/fe-utils'
import WaterfallProductItem from './WaterfallProductItem'

// interface
type TProductItem = 'waterfall' | 'recommend' | 'classic' | 'list';
interface IProps {
  type?: TProductItem;
  product: IMallViewProduct;
  style?: any;
  count?: number;
  lazy?: boolean;
  backgroundMode?: 'light' | 'dark';
  imgLoaded?: boolean;
  decorate?: IMallGlobalDecorates;
}
// 瀑布流图片的宽度
const ProductItem: React.FC<IProps> = ({ type = 'waterfall', product, style, count, lazy = false, backgroundMode = 'light', imgLoaded = false, decorate }) => {
  return (
    <WaterfallProductItem
      decorate={decorate}
      type={type} product={product} style={style} count={count}
      lazy={lazy} backgroundMode={backgroundMode} imgLoaded={imgLoaded}
    />
  )
}

const areEqual = function (prevProps: IProps, nextProps: IProps) {
  return !!areEqualProps(prevProps, nextProps, [
    'count',
    'product.id',
    'product.soldout',
    'product.actualPrice',
    'product.soldout',
    'product.memberPrice',
    'product.offPrice',
    'product.isMemberDiscount',
    'imgLoaded',
    'style.left',
    'style.top',
    'mealDecorates'
  ])
}
export default memo(ProductItem, areEqual)
